import {connect} from 'react-redux';
import {settingsActions} from '../../redux/settings';
import {getSettings} from '../../pages/campaigns/utils';

function mapState(state: any) {
  const settings = getSettings(state);
  return {
    client: state.client.data,
    users: state.users.list,
    isNavCollapsed: settings.isNavCollapsed,
    isAdmin: state.settings.isAdmin,
    unreadCountByUser: state.inbox.unreadCountByUser,
    initialConversationsLoading: state.inbox.initialConversationsLoading,
    openMenuItems: settings.openMenuItems,
  }
}

const actionCreators = {
  setSettings: settingsActions.setSettings,
};

export default connect(mapState, actionCreators);
